import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-navi-item-link-for-sp-on-general" }
const _hoisted_2 = ["target", "href"]
const _hoisted_3 = {
  key: 0,
  class: "p-navi-item-link-for-sp-on-general__link__icon"
}
const _hoisted_4 = {
  key: 0,
  class: "p-navi-item-link-for-sp-on-general__link__notification"
}
const _hoisted_5 = { class: "p-navi-item-link-for-sp-on-general__link__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLabelNewArrivalCount = _resolveComponent("TextLabelNewArrivalCount")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("a", {
      target: _ctx.target,
      href: _ctx.url,
      class: "p-navi-item-link-for-sp-on-general__link"
    }, [
      (_ctx.$slots.icon)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3, [
            (_ctx.hasNotification && !_ctx.isGroupBudget)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_TextLabelNewArrivalCount, { count: _ctx.formatNotificationCount }, null, 8, ["count"])
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "icon", {}, () => [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": _ctx.iconColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowRight)
                ]),
                _: 1
              }, 8, ["icon-color"])
            ], true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.label), 1)
    ], 8, _hoisted_2)), [
      [_directive_touch, void 0, "tap"]
    ]),
    _renderSlot(_ctx.$slots, "content", {}, undefined, true)
  ]))
}